import { HousePlus, MapPin, Music, LucideIcon } from "lucide-react";
import { Trans } from "@lingui/react/macro";
import { ReactNode } from "react";

interface SearchBarSectionProps {
  icon: LucideIcon;
  label: ReactNode;
  value?: string;
}

function SearchBarSection({ icon: Icon, label, value }: SearchBarSectionProps) {
  const selected = !!value;

  return (
    <div
      className={`flex min-w-0 flex-1 flex-row items-center justify-center gap-2 px-2 md:px-0 ${
        selected
          ? "text-soluud-text-primary opacity-100"
          : "text-soluud-text-tertiary opacity-60"
      }`}
    >
      <Icon size={18} className="shrink-0" aria-hidden="true" />
      <div className="hidden min-w-0 flex-col md:flex">
        <span className="truncate text-xs font-light">{label}</span>
        <span className="truncate text-sm">{value ?? "-"}</span>
      </div>
    </div>
  );
}

interface SearchBarPlaceholderProps {
  translatedInstrument?: string;
  translatedLessonFormat?: string;
  locationLabel?: string;
}

export function SearchBarPlaceholder({
  translatedInstrument,
  translatedLessonFormat,
  locationLabel,
}: SearchBarPlaceholderProps) {
  return (
    <div className="ml-4 flex w-full min-w-0 flex-row justify-evenly sm:ml-0">
      <SearchBarSection
        icon={Music}
        label={<Trans>Instrument</Trans>}
        value={translatedInstrument}
      />
      <SearchBarSection
        icon={HousePlus}
        label={<Trans>Lesson format</Trans>}
        value={translatedLessonFormat}
      />
      <SearchBarSection
        icon={MapPin}
        label={<Trans>Location</Trans>}
        value={locationLabel}
      />
    </div>
  );
}
